#import "../../../../graphql-wrappers/graphql/fragments/audience-fragment.graphql"
#import "../../../engagement/graphql/fragments/sms-edition-engagement-stats-fragment.graphql"

fragment SmsEditionFragment on SmsEdition {
    id
    name
    htmlUrlPath
    content
    createdTime
    deletedTime
    scheduledTime
    modifiedTime
    status
    from {
        id
        status
        phone {
            numberFormatted
        }
    }
    campaign {
        id
        name
        deletedTime
        type
        owner {
            id
        }
    }
    optOutText
    engagementStats {
        ...SmsEditionEngagementStatsFragment
    }
    audience {
        ...AudienceFragment
    }
    hasShortLink
    gateError {
        reason
        message
    }
    smsCampaignsCreditLimit
    smsCampaignsCreditsUsed
}
